import { render, staticRenderFns } from "./reset-password-search.vue?vue&type=template&id=07ac0930&scoped=true"
import script from "./reset-password-search.vue?vue&type=script&lang=js"
export * from "./reset-password-search.vue?vue&type=script&lang=js"
import style0 from "./reset-password-search.vue?vue&type=style&index=0&id=07ac0930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ac0930",
  null
  
)

export default component.exports